import { Heading } from '@/src/tailwindui/heading';

export default function FeatureRequest() {
    return (
        <div className="mx-auto max-w-4xl">
            <div>
                <Heading className="text-3xl md:text-4xl plex-sans">
                    Feature Request
                </Heading>
            </div>
            <div>
                <p className="text-muted-foreground plex-sans text-[#000] dark:text-[#fff]">
                    We are always looking for feedback from our users. If you
                    have any feature requests, please let us know.
                </p>
            </div>
            <div className="mt-8 w-full">
                {/* @ts-ignore */}
                <iframe
                    src="https://savory-baroness-9f0.notion.site/ebd/1cf256f15b7380189233fa28fe850bc9"
                    width="100%"
                    height="1200px"
                />
            </div>
        </div>
    );
}
